export const TITLE_HEIGHT = 48;

export const FIELD_HEIGHT = 32;

export const NOTE_HEIHT = 20;
